export enum LOCATION_AREA_ENUM {
  LATAM = 'LatAm',
  EUROPE = 'Europe',
  OTHERS = 'Other Locations',
}
